import React from "react";
import "./StepIndicator.css"; // For styling

const StepIndicator = ({ activeStep, steps, onStepClick  }) => {
  return (
    <div className="nykaa-step-indicator">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`step-item ${
            activeStep > index ? "completed" : activeStep === index ? "active" : ""
          }`}
          onClick={() => {
            if (activeStep > index) {
              onStepClick(index); 
            }
          }}
        >
          <div className="step-circle">
            {activeStep > index ? <i className="ri-check-fill"></i> : index + 1}
          </div>
          <div className="step-label">{step.label}</div>
          {index < steps.length - 1 && <div className="step-line"></div>}
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;
